import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import "lenis/dist/lenis.css";

export const SmoothScroll = () => {
  const { pathname, hash } = useLocation();
  const lenis = useRef(null);

  useEffect(() => {
    const l = new Lenis({ lerp: 0.085, anchors: { offset: -72 } });
    lenis.current = l;
    let id;
    const raf = (t) => { l.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); l.destroy(); };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    lenis.current?.scrollTo(0, { immediate: true });
  }, [pathname]);

  useEffect(() => {
    if (!/^#[a-z][\w-]*$/.test(hash)) return undefined;
    // Section anchors (e.g. /que-es-mutoni#proyecto): wait for layout, then jump.
    const t = setTimeout(() => {
      const el = document.querySelector(hash);
      if (el) lenis.current?.scrollTo(el, { offset: -72, immediate: true });
    }, 450);
    return () => clearTimeout(t);
  }, [pathname, hash]);

  return null;
};
